module.exports = __webpack_public_path__ + "img/favicon.41d8b757.ico";